module.exports = __webpack_public_path__ + "img/D0020.1d8b710f.svg";